import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-pays-checkbox',
  imports: [NgStyle],
  templateUrl: './pays-checkbox.component.html',
})
export class PaysCheckboxComponent {
  @Input({ required: true }) id!: string;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) control!: boolean;
  @Output() controlChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() bigCheckbox: boolean = true;

  onChange() {
    this.control = !this.control;
    this.controlChange.emit(this.control);
  }
}
